export default __webpack_public_path__ + "static/media/walking-icon.efa90cb2.svg";